module.exports = __webpack_public_path__ + "static/media/state-back-15.8fa43418.jpg";